import {
  CircularProgress,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Link,
  Typography,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import { getValue } from "@mui/system";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCitiesById } from "services/commonServices";
import { updateCity } from "services/commonServices";
import MDBox from "../../../components/MDBox/index";
import MDInput from "../../../components/MDInput/index";
import SelectDropDown from "../../../examples/DropDown/index";
import {
  getCitybyId,
  setUsersDropdown,
  updateCityy,
} from "../Redux/actionCreator";
import { setProfessionType } from "layouts/events/Redux/actionCreator";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import Moment from "moment";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";


const label = { inputProps: { "aria-label": "Checkbox demo" } };


const ROW_HEIGHT = 56;
const MAX_VISIBLE_ROWS = 3;

const valueTypeMap = {
  AbsoluteByPercentage: "AbsoluteByPercentage",
  AbsoluteByValue: "AbsoluteByValue",
};

const CityDetailsForm = () => {
  const [passwordButton, setPasswordButton] = useState(true);

  // const validationSchema=yup.object().shape({
  //   value:yup.string()
  //   .required("Value is Required")
  //   .matches(/^[0-9\s]+$/, "Invalid Value")
  // })

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [responsedata, setResponseData] = useState([]);
  const [isLaunched, setIsLaunched] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const url = window.location.href.split("cities")[1].split("/")[1];

  const [monetizationType, setMonetizationType] = useState({});
  const [loading, setLoading] = useState(true);

  const { Profession_Type_Data } = useSelector((state) => state.events);
  const professionData = Profession_Type_Data?.professionInfo || [];

  const professionOptions = professionData.map((p) => ({
    key: p._id,
    value: p.name,
  }));

  // const getData = async () => {
  //   let response = await getCitiesById(url);
  //   setResponseData(response);
  //   setIsLaunched(response[0].isLaunched);
  //   return response[0];
  // };

  // const {
  //   register,
  //   setValue,
  //   handleSubmit,
  //   control,
  //   getValues,
  //   watch,
  //   reset,
  //   formState: { errors },
  // } = useForm(
  //   { defaultValues: () => getData() },
  //   // { resolver: yupResolver(schema) }
  // );

  const { register, setValue, handleSubmit, control, reset, watch } = useForm({
    defaultValues: {
      monetization: {},
    },
  });

  // const data1 = getValues();

  // const handleCheckboxChange = (isChecked) => {
  //   setIsLaunched(isChecked);

  //   // Show the popup when Checkbox is checked
  //   if (isChecked) {
  //     setShowPopup(true);
  //   }else{
  //     setShowPopup(false);
  //   }
  // };
  // useEffect(() => {
  //   const storedData = localStorage.getItem("IsLaunched");
  //   if (storedData) {
  //     setIsLaunched(JSON.parse(storedData).isLaunched);
  //   }else{
  //     setIsLaunched(true)
  //   }
  // }, []);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    // console.log("isChecked", isChecked);
    setIsLaunched(isChecked);
    setValue("isLaunched", isChecked);

    if (isChecked) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  };

  const handlePopupResponse = (response) => {
    setShowPopup(false);
    if (response === "Yes") {
      setIsLaunched(true);
    } else {
      setIsLaunched(false);
    }
  };

  /* ----------- Transform backend → RHF ----------- */

  const transformDefaultMonetization = (
    defaultMonetization = [],
    professions = []
  ) => {
    const monetization = {};

    professions.forEach((p) => {
      monetization[p.key] = { type: "AbsoluteByPercentage", value: "" };
    });

 
    defaultMonetization.forEach((item) => {
      monetization[item.professionType] = {
        type: item.valueType,
        value: item.value,
      };
    });

    return monetization;
  };
  const hasEmptyMonetizationValue = (monetization = {}) => {
    for (const key in monetization) {
      const value = monetization[key]?.value;

      if (value === "" || value === undefined || value === null) {
        return true;
      }
    }
    return false;
  };


 
  const handleReset = () => {
    reset();
  };

  const { UsersData } = useSelector((state) => state.common);
  const userInfo = UsersData?.usersInfo;
  const userOptions = [];

  userInfo.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    userOptions.push(obj);
  });

  const handleCreatedByChange = (e) => {
    setValue("createdBy", e.target.value);
    let userID;
    userOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });
  };
  const handleUpdatedByChange = (e) => {
    setValue("updatedBy", e.target.value);
    let userID;
    userOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });
  };
  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(setProfessionType());
    dispatch(setUsersDropdown());
    // getData();
  }, []);

  // console.log("professionOptions", professionOptions);
  useEffect(() => {
    const fetchCity = async () => {
      const res = await getCitiesById(url);
      const city = res[0];

      console.log("city", city);

      setIsLaunched(city.isLaunched);
      setValue("name", city.name);
      setValue("isDeleted", city.isDeleted);
      setValue("isLaunched", city.isLaunched);
      setValue("createdAt", Moment(city.createdAt).format("DD/MM/YY"));
      setValue("updatedAt", Moment(city.updatedAt).format("DD/MM/YY"));
     setValue(
       "createdBy.name.full",
       `${city?.createdBy?.name?.first || ""} ${
         city?.createdBy?.name?.last || ""
       }`.trim()
     );

     setValue(
       "updatedBy.name.full",
       `${city?.updatedBy?.name?.first || ""} ${
         city?.updatedBy?.name?.last || ""
       }`.trim()
     );


      if (professionOptions.length) {
        const monetization = transformDefaultMonetization(
          city.defaultMonetization,
          professionOptions
        );

        setValue("monetization", monetization);

        const typeState = {};
        Object.keys(monetization).forEach(
          (k) => (typeState[k] = monetization[k].type)
        );
        setMonetizationType(typeState);
      }

      setLoading(false);
    };

    if (professionOptions.length) fetchCity();
  }, [professionOptions.length]);

  // const formValues = getValues();

  const [created, setCreated] = useState(false);
  const [updated, setUpdated] = useState(false);

   const onSubmit = async (data) => {
    //  console.log("data>>>", data); 

     if (hasEmptyMonetizationValue(data.monetization)) {
       toast.error("Please fill all values before saving");
       return;
     }

     const defaultMonetization = Object.keys(data.monetization).map((key) => ({
       professionType: key,
       valueType: valueTypeMap[data.monetization[key].type],
       value: Number(data.monetization[key].value),
     }));

     const payload = {
       name: data.name,
       isDeleted: data.isDeleted,
       isLaunched: data.isLaunched,
       defaultMonetization,
     };
     // console.log("payload", payload);
     // localStorage.setItem("IsLaunched", JSON.stringify({ isLaunched: data.isLaunched }));
     dispatch(updateCityy({ payload: payload, id: url })).then(() => {
       navigate("/common/cities");
     });
   };
  // useEffect(() => {
  //   let createdAT = getValues("createdAt");
  //   let updatedAT = getValues("updatedAt");

  //   if (createdAT == "Invalid date") {
  //     setValue("createdAt", "");
  //     setCreated(true);
  //   }
  //   if (updatedAT !== "Invalid date") {
  //     setValue("updatedAt", "");
  //     setUpdated(true);
  //   }
  //   if (createdAT != undefined && createdAT !== "") {
  //     if (!created) {
  //       setValue("createdAt", Moment(createdAT).format("DD/MM/YY"));

  //       setCreated(true);
  //     }
  //   }

  //   if (updatedAT == "Invalid date") {
  //     setValue("updatedAt", "");
  //     setUpdated(true);
  //   }

  //   if (updatedAT != undefined && updatedAT !== "") {
  //     if (!updated) {
  //       setValue("updatedAt", Moment(updatedAT).format("DD/MM/YY"));

  //       setUpdated(true);
  //     }
  //   }
  // }, [getValues("createdAt"), getValues("updatedAt")]);
  // console.log("162-->", )

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: 200 }}
      >
        <CircularProgress />
      </div>
    );
  }
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox margin={2}>
          <Grid item xs={12}>
            <div style={{ display: "flex", width: "70px" }}>
              <Link onClick={handleBack}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <ArrowBackIos fontSize="small" />
                  back
                </div>
              </Link>
            </div>
          </Grid>
          {/* <Divider /> */}
          <DialogContent>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                {/* Name Title */}
                <Grid item xs={8}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    placeholder=""
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    name="name"
                    {...register("name")}
                  />
                </Grid>
                {/* ID */}
                <Grid item xs={12}>
                  <Typography variant="body">
                    ID:{responsedata[0]?._id}
                  </Typography>
                </Grid>
                {/* is Deleted */}
                <Grid item xs={12} md={12}>
                  <Grid item xs={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Controller
                            defaultValue={false}
                            name="isDeleted"
                            control={control}
                            render={({ field: props }) => (
                              <Checkbox
                                {...props}
                                checked={props.value}
                                onChange={(e) =>
                                  props.onChange(e.target.checked)
                                }
                              />
                            )}
                          />
                        }
                        label="Is Deleted"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
                {/* is Launched */}
                <Grid item xs={12} md={12}>
                  <Grid item xs={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Controller
                            defaultValue={false}
                            name="isLaunched"
                            control={control}
                            render={({ field: props }) => (
                              <Checkbox
                                {...props}
                                // checked={props.value}
                                // onChange={(e) =>
                                //   props.onChange(e.target.checked)
                                // }
                                checked={isLaunched}
                                onChange={(e) => handleCheckboxChange(e)}
                              />
                            )}
                          />
                        }
                        label="Is Launched"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
                {/* Popup Component */}
                <Dialog open={showPopup} onClose={() => setShowPopup(false)}>
                  <DialogTitle>Launch City</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Do you want to launch this city?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => handlePopupResponse("Yes")}>
                      Yes
                    </Button>
                    <Button onClick={() => handlePopupResponse("No")}>
                      No
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Monetization Section */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <div
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      padding: "12px",
                      // background: "#f5f5f5",
                    }}
                  >
                    {/* Header */}
                    <Grid
                      container
                      sx={{
                        fontWeight: "bold",
                        pb: 1,
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <Grid item xs={4}>
                        Profession
                      </Grid>
                      <Grid item xs={4}>
                        Type
                      </Grid>
                      <Grid item xs={4}>
                        Value
                      </Grid>
                    </Grid>

                    {/* Scrollable Rows */}
                    <div
                      style={{
                        maxHeight: ROW_HEIGHT * MAX_VISIBLE_ROWS, // 3 rows visible
                        overflowY: "auto",
                        marginTop: "8px",
                        paddingRight: "6px",
                      }}
                    >
                      {professionOptions.map((item) => (
                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          key={item.key}
                          sx={{
                            py: 0.75,
                            borderBottom: "1px solid #f3f3f3",
                            "&:last-child": { borderBottom: "none" },
                          }}
                        >
                          {/* Profession */}
                          <Grid item xs={4}>
                            {item.value}
                          </Grid>

                          {/* Type */}
                          <Grid item xs={4}>
                            <Controller
                              name={`monetization.${item.key}.type`}
                              control={control}
                              defaultValue="AbsoluteByPercentage"
                              render={({ field }) => (
                                <MDInput
                                  select
                                  fullWidth
                                  SelectProps={{ native: true }}
                                  {...field}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    setMonetizationType((prev) => ({
                                      ...prev,
                                      [item.key]: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="AbsoluteByPercentage">
                                    percentage
                                  </option>
                                  <option value="AbsoluteByValue">value</option>
                                </MDInput>
                              )}
                            />
                          </Grid>
                          {/* Value */}
                          <Grid item xs={4}>
                            <Controller
                              name={`monetization.${item.key}.value`}
                              control={control}
                              render={({ field }) => (
                                <MDInput
                                  {...field}
                                  type="text"
                                  value={field.value === "" ? "" : field.value}
                                  fullWidth
                                 
                                  placeholder={
                                    monetizationType[item.key] === "value"
                                      ? "Enter value"
                                      : "Enter %"
                                  }
                                  inputProps={{
                                    inputMode: "decimal",
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d*$/.test(value)) {
                                      field.onChange(value);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </div>
                  </div>
                </Grid>

                {/* CreatedAt */}
                <Grid item xs={4}>
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "80%", marginTop: "0.8rem" }}
                  >
                    Created At
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <MDInput
                    disabled
                    placeholder=""
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    name="createdAt"
                    // defaultValue={responsedata[0]?.createdAt}

                    {...register("createdAt")}
                  />
                </Grid>
                {/* Updated At */}
                <Grid item xs={4}>
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "80%", marginTop: "0.8rem" }}
                  >
                    Updated At
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <MDInput
                    disabled
                    placeholder=""
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    name="updatedAt"
                    {...register("updatedAt")}
                  />
                </Grid>
                {/* CreatedBy */}
                <Grid item xs={4}>
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "80%", marginTop: "0.8rem" }}
                  >
                    Created By
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <MDInput
                    disabled
                    placeholder=""
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    name="createdBy"
                    {...register("createdBy.name.full")}
                  />
                </Grid>
                {/* updatedBy */}
                <Grid item xs={4}>
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "80%", marginTop: "0.8rem" }}
                  >
                    Updated By
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <MDInput
                    disabled
                    placeholder=""
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    name="updatedBy"
                    {...register("updatedBy.name.full")}
                  />
                </Grid>
              </Grid>
              <div style={{ marginTop: "2rem" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ color: "#fff" }}
                >
                  Save
                </Button>
                {/* <Button
                    variant="outlined"
                    sx={{ color: "#111", marginLeft: "1rem" }}
                    onClick={handleReset}
                  >
                    Reset
                  </Button> */}
              </div>
            </form>
          </DialogContent>
        </MDBox>
      </DashboardLayout>
    </>
  );
};
export default CityDetailsForm;
